import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown, Image } from "react-bootstrap";
import DummyAvatar from "../../assets/images/Profile-thumbnail-small.svg";
import { useSelector } from "react-redux";

export default function AllCoursesForInstructor({ courses }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const auth = useSelector((state) => state.auth);

  // Ensure valid course array
  const courseList = Array.isArray(courses) ? courses : [];

  // Pagination logic
  const totalPages = Math.max(1, Math.ceil(courseList.length / rowsPerPage));
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentCourses = courseList.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleRowsChange = (event) => {
    const value = Number(event.target.value);
    setRowsPerPage(value > 0 ? value : 10);
    setCurrentPage(1);
  };

  return (
    <>
      {/* Mobile rows-per-page selector */}
      <div className="d-flex align-item-center justify-content-end d-sm-none mb-3">
        <label className="me-2 flex-shrink-0 align-self-center">
          No of Rows
        </label>
        <select
          className="form-control ms-16"
          value={rowsPerPage}
          onChange={handleRowsChange}
          style={{ width: "100px" }}
        >
          {[10, 20, 30, 40, 50].map((val) => (
            <option key={val} value={val}>
              {val}
            </option>
          ))}
        </select>
      </div>

      <div className="table-responsive mb-10">
        <table className="table instructor-course-table custom-table">
          <thead className="position-sticky top-0 z-3">
            <tr>
              <th>Sr No.</th>
              <th>Course Name</th>
              <th className="text-center">Enrolled Students</th>
              {/* <th>Reviews</th> */}
              <th className="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            {courseList.length === 0 ? (
              <tr>
                <td colSpan={4} className="text-center">
                  <div className="alert alert-info">No courses available.</div>
                </td>
              </tr>
            ) : (
              currentCourses.map((course, index) => (
                <tr key={course.id}>
                  <td>{startIndex + index + 1}</td>
                  <td>
                    <div className="d-flex align-items-center">
                      <div className="img-holder me-15 flex-shrink-0">
                        <Image
                          src={
                            process.env.REACT_APP_GALLERY_URL +
                            JSON.parse(course?.image_urls)?.[0]
                          }
                          alt={`Thumbnail ${index + 1}`}
                          className="img-fluid h-100"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = DummyAvatar;
                          }}
                        />
                      </div>
                      <strong className="ah-text-sm fw-semibold text-black">
                        {course.title}
                      </strong>
                    </div>
                  </td>
                  <td className="text-center fw-medium">
                    {course.enrolledStudentsCount}
                  </td>
                  <td className="text-center">
                    <Dropdown className="custom-dropdown">
                      <Dropdown.Toggle className="icon-btn p-5">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="9" cy="4.625" r="1.09375" fill="#F05203" />
                          <circle cx="9" cy="9" r="1.09375" fill="#F05203" />
                          <circle cx="9" cy="13.375" r="1.09375" fill="#F05203" />
                        </svg>
                      </Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        <Dropdown.Item
                          as={Link}
                          to={
                            auth.role === "Admin"
                              ? `/admin-course-detail?id=${course.id}`
                              : auth.role === "Instructor"
                                ? `/instructor-course-detail?id=${course.id}`
                                : "#"
                          }
                        >
                          <svg
                            width="20"
                            height="13"
                            viewBox="0 0 20 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 0.539062C6.17879 0.539062 2.71351 2.62968 0.15649 6.02541C-0.0521632 6.30361 -0.0521632 6.69228 0.15649 6.97048C2.71351 10.3703 6.17879 12.4609 10 12.4609C13.8212 12.4609 17.2865 10.3703 19.8435 6.97457C20.0522 6.69637 20.0522 6.3077 19.8435 6.0295C17.2865 2.62968 13.8212 0.539062 10 0.539062ZM10.2741 10.6976C7.73755 10.8572 5.64284 8.76653 5.80239 6.22588C5.93331 4.13117 7.63118 2.4333 9.72589 2.30238C12.2625 2.14283 14.3572 4.23345 14.1976 6.7741C14.0626 8.86472 12.3647 10.5626 10.2741 10.6976ZM10.1473 8.75835C8.78081 8.84427 7.65163 7.71918 7.74164 6.35271C7.81119 5.22353 8.72763 4.31118 9.85681 4.23754C11.2233 4.15162 12.3525 5.27671 12.2625 6.64318C12.1888 7.77646 11.2724 8.6888 10.1473 8.75835Z"
                              fill="#F05203"
                            />
                          </svg>
                          View Details
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              )))}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="d-flex justify-content-center justify-content-sm-between align-items-center custom-pagination-holder">
        <div>
          <button
            className="me-2 border-0 bg-transparent p-0"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <svg
              style={{ transform: "rotate(-90deg)" }}
              width="12"
              height="10"
              viewBox="0 0 17 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7646 8.65686L8.76465 1.65686L1.76465 8.65686"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>{" "}
            Prev
          </button>

          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i + 1}
              className={`bg-transparent border-0 ${currentPage === i + 1
                  ? "pagination-item active"
                  : "pagination-item"
                } me-2`}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </button>
          ))}

          <button
            className="me-2 border-0 bg-transparent p-0"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next{" "}
            <svg
              style={{ transform: "rotate(90deg)" }}
              width="12"
              height="10"
              viewBox="0 0 17 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7646 8.65686L8.76465 1.65686L1.76465 8.65686"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        {/* Desktop rows-per-page selector */}
        <div className="align-item-center d-none d-sm-flex">
          <label className="me-2 flex-shrink-0 align-self-center">
            No of Rows
          </label>
          <select
            className="form-control ms-16"
            value={rowsPerPage}
            onChange={handleRowsChange}
            style={{ width: "100px" }}
          >
            {[10, 20, 30, 40, 50].map((val) => (
              <option key={val} value={val}>
                {val}
              </option>
            ))}
          </select>
        </div>
      </div>
    </>
  );
}
